<template>
  <div id="salesmanList" v-loading="exportLoading">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="100">
      <FormItem class="form_item" :label="$t('conditionWorkNumOrZh')" >
        <Input clearable size="default" v-model="userAccount" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('conditionName')">
        <Input clearable size="default" v-model="empName" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('userEmail1')">
        <Input clearable size="default" v-model="empEmail" :placeholder="$t('enter')"/>
      </FormItem>
      <FormItem class="form_item" :label="$t('hasRole1')">
        <el-radio-group v-model="hasRole" >
          <el-radio :label="1">{{$t('ISLH Users')}}</el-radio>
          <el-radio :label="0">{{$t('Employees')}}</el-radio>
        </el-radio-group>
      </FormItem>
      <div class="buttonDiv">
        <el-button v-has="{class:'UserInfoQuery'}" type="primary" size="mini" @click="searchSysUser">{{$t('search')}}</el-button>
        <el-button v-has="{class:'UserExport'}" type="primary" size="mini" @click="exportExcel">{{$t('export')}}</el-button>
        <el-button v-has="{class:'UserInfoADD'}" type="primary" size="mini" @click="addUser">{{$t('add')}}</el-button>
        <el-button v-has="{class:'UserInfoReset'}" type="primary" size="mini" @click="handleReset">{{$t('resetPassword')}}</el-button>
      </div>
    </Form>

    <div class="contentTableDiv">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="userAccount" :label="$t('yuNo')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="empName" :label="$t('name')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="empEmail" :label="$t('userEmail')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="userLocation" :label="$t('userLocation')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="roleName" :label="$t('roleAssigned')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="dataPower" :label="$t('userDataEmpower')" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createTime" :label="$t('createTime')" align="center" width="165"></el-table-column>
        <el-table-column :label="$t('operate')" align="center" fixed="right"  width="200">
          <template slot-scope="scope">
            <el-dropdown trigger="click" >
              <el-button size="mini" type="primary">{{$t('operate')}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><el-button v-has="{class:'UserEmpower'}" v-if="scope.row.accountStatus==0" size="mini" type="success" @click="handleEmpower(scope.row)">{{$t('empower')}}</el-button></el-dropdown-item>
                <el-dropdown-item><el-button v-has="{class:'UserInfoUpdate'}" v-if="scope.row.accountStatus==0" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button></el-dropdown-item>
                <el-dropdown-item><el-button v-has="{class:'UserFreeze'}" v-if="scope.row.accountStatus==0" size="mini" type="danger" @click="handleFreeze(scope.row)">{{$t('freeze')}}</el-button></el-dropdown-item>
                <el-dropdown-item><el-button v-has="{class:'UserUnFreeze'}" v-if="scope.row.accountStatus==1" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button></el-dropdown-item>
                <el-dropdown-item><el-button size="mini" type="danger" @click="handleHour(scope.row)">{{$t('additionalRecording')}}</el-button></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]"
         :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>

    <!-- <el-dialog :title="$t('addUserInfo')" :visible.sync="modelAdd" width="45%" :close-on-press-escape="false" :close-on-click-modal="false" :before-close="close">
        <el-tabs value="first" type="border-card">
	        <el-tab-pane name="first" :label="$t('outterUser')">
            <el-form :model="addUserForm" ref="addUserForm" :rules="rules" label-width="100px">
                <el-row>
                  <el-col :xs="24" :md="24">
                    <el-form-item :label="$t('conditionWorkNumOrZh')" prop="userAccount" >
                      <el-input v-if="updateFlag==0" v-model="addUserForm.userAccount" :placeholder="$t('loginname')" clearable/>
                      <el-input v-if="updateFlag==1" v-model="addUserForm.userAccount" disabled/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :md="24">
                    <el-form-item :label="$t('conditionName')" prop="empName">
                      <el-input clearable v-model="addUserForm.empName" :placeholder="$t('inputUserName')"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :md="24">
                    <el-form-item :label="$t('conditionMailbox')" prop="empEmail">
                      <el-input v-model="addUserForm.empEmail" :placeholder="$t('enterEmail')"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col style="margin-top: 5px; text-align: center;" :xs="24" :md="24">
                    <el-button type="primary" size="small" @click="close">{{$t('cancle')}}</el-button>
                    <el-button type="primary" size="small" @click="submitUserForm('addUserForm')">{{$t('confrim')}}</el-button>
                  </el-col>
                </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
    </el-dialog> -->
    <Modal v-model="modelAdd" :closable='true' :mask-closable='false' :title="$t('addUserInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitUserForm('addUserForm')">{{$t('confrim')}}</Button>
      </div>
      <el-tabs value="first" type="border-card">
        <el-tab-pane name="first" :label="$t('outterUser')">
          <el-form :model="addUserForm" ref="addUserForm" :rules="rules" label-width="100px">
              <el-row>
                <el-col :xs="24" :md="24">
                  <el-form-item :label="$t('conditionWorkNumOrZh')" prop="userAccount" >
                    <el-input v-if="updateFlag==0" v-model="addUserForm.userAccount" :placeholder="$t('loginname')"/>
                    <el-input v-if="updateFlag==1" v-model="addUserForm.userAccount" disabled/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="24">
                  <el-form-item :label="$t('conditionName')" prop="empName">
                    <el-input v-model="addUserForm.empName" :placeholder="$t('inputUserName')"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="24">
                  <el-form-item :label="$t('conditionMailbox')" prop="empEmail">
                    <el-input v-model="addUserForm.empEmail" :placeholder="$t('enterEmail')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </Modal>
    <Modal v-model="modelEmpower" :closable='true' :mask-closable='false' :title="$t('userEmpower')">
      <div slot="footer">
        <Button type="primary" size="small" @click="closeEmpower">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitEmpower">{{$t('confrim')}}</Button>
      </div>
      <el-tabs value="first" type="border-card">
        <el-tab-pane name="first" :label="$t('userRoleEmpower')">
          <el-table :data="roleData" ref="roleTable" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @selection-change="handleRoleChange">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column prop="roleId" v-if="false" ></el-table-column>
            <el-table-column prop="name" :label="$t('roleName')" align="center"></el-table-column>
            <el-table-column prop="description" :label="$t('roleDescripe')" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="second" :label="$t('userDataEmpower')">
          <el-table :data="dataPermissions" ref="dataTable" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @selection-change="handleDataChange">
            <el-table-column type="selection" :selectable="checkSelect" width="50" align="center"></el-table-column>
            <el-table-column prop="id" v-if="false" ></el-table-column>
            <el-table-column prop="sysDesc" :label="$t('permissionDesc')" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </Modal>
    <Modal v-model="modelHour" id="suffixId" :closable='true' :mask-closable='false' :title="$t('Labour Hour')">
      <div slot="footer">
        <Button type="primary" size="small"  @click="closeEmpower">{{$t('cancle')}}</Button>
        <Button type="primary" size="small"  @click="submitHour">{{$t('confrim')}}</Button>
      </div>
      <el-form label-width="100px">
        <el-form-item :label="$t('Work Date：')" >
          <el-date-picker v-model="extraDate" :picker-options="pickerOptions" :editable="true" clearable type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'user',
        created () {
           this.getSysUser();
           this.getRolesList();
           this.getDataPermissions();
        },
        data () {
            var checkUserAccount = (rule, value, callback) => {
              if(this.updateFlag == 0){
                let reg = /^\S*$/;
                if(!reg.test(value)){
                  return callback(new Error("User ID cannot contain spaces"));
                }
                let params = {
                  userAccount : value,
                }
                let url =`${this.$store.state.islhurl}checkUserAccount`
                this._post(url,params).then(
                  res => {      
                    if(res.code == '0'){
                      var msg = this.$t('userMsg')
                      return callback(new Error(msg));
                    }else{
                      callback();
                    }
                  }
                )
              }else{
                callback();
              }
            };
            var checkEmail = (rule, value, callback) => {
              let reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
              if(!reg.test(value)){
                var msg = this.$t('userMsg1')
                return callback(new Error(msg));
              }else{
                callback();
              }
            }
            return {
              pickerOptions: {disabledDate: time => {return this.selectWorkDate(time)}},
              hasRole:1,
              empName: null,
              userAccount:null,
              empEmail:null,
              tableData: [],
              roleData:[],
              dataPermissions:[],
              multipleSelection:[],
              multipleRole:[],
              multipleData:[],
              addUserForm:{
                empName:null,
                userAccount:null,
                empEmail:null,
              },
              userId:null,
              uAccount:null,
              extraDate:null,
              modelAdd:false,
              modelHour:false,
              modelEmpower:false,
              exportLoading:false,
              updateFlag:0,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
              rules: {
                userAccount: [
                  { required: true, message: this.$t('loginname'), trigger: 'blur' },
                  { validator:checkUserAccount, trigger: 'blur' }
                ],
                empName: [
                  { required: true, message: this.$t('inputUserName'), trigger: 'blur' },
                ],
                empEmail: [
                  { required: true, message: this.$t('enterEmail'), trigger: 'blur' },
                  {validator:checkEmail, trigger: 'blur' }
                ],
              },
            }
        },
        methods: {
            selectWorkDate(time){
              return (time > new Date());
            },
            getSysUser(){
              let url = `${this.$store.state.islhurl}getSysUser/${this.pageSize}/${this.currentPage}`
              let pm = {
                userAccount: this.userAccount==''?null:this.userAccount,
                empName: this.empName==''?null:this.empName,
                empEmail: this.empEmail==''?null:this.empEmail,
                hasRole: this.hasRole,
                islhToken: sessionStorage.getItem('islhtoken')
              }
              // console.log(pm)
              this._post(url,pm).then(
                res =>{
                  if(res.code == 200){
                    this.tableData =res.data;
                    this.totalCount = res.totalNums;
                  }else{
                    this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res.message
                      });
                  }
                }
              )
            },
            searchSysUser(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}getSysUser/${this.pageSize}/${this.currentPage}`
              let pm = {
                userAccount: this.userAccount==''?null:this.userAccount,
                empName: this.empName==''?null:this.empName,
                empEmail: this.empEmail==''?null:this.empEmail,
                hasRole: this.hasRole,
                islhToken: sessionStorage.getItem('islhtoken')
              }
              // console.log(pm)
              this._post(url,pm).then(
                res =>{
                  if(res.code == 200){
                    this.tableData =res.data;
                    this.totalCount = res.totalNums;
                  }else{
                    this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res.message
                      });
                  }
                  
                }
              )
            },
            getRolesList(){
              let url = `${this.$store.state.islhurl}getAllRoleList`
              this._get(url).then(
                res =>{
                  this.roleData = res.data;
                }
              )
            },
            getDataPermissions(){
              let url = `${this.$store.state.islhurl}keyValue/getList`
              let pm = {
                sysKey: 'DataPermission',
              }
              this._post(url,pm).then(
                res =>{
                  this.dataPermissions = res.data;
                }
              )
            },
            checkSelect (row,index) {
              let isChecked = true;
              if (row.sysValue === 'Responsible' || row.sysValue === 'Founder') {
                isChecked = false
              } else {
                isChecked = true
              }
              return isChecked
            },
            submitUserForm(formName){
                this.$refs[formName].validate((valid) => {
                if (valid) {
                  if(this.updateFlag == 0){
                    this.addUserInfo();
                  }else if(this.updateFlag == 1){
                    this.modifyUser();
                  }
                } else {
                  console.log("submit error")
                  return false;
                }
              });
            },
            addUserInfo(){
              let params ={
                userAccount : this.addUserForm.userAccount,
                empName : this.addUserForm.empName,
                empEmail : this.addUserForm.empEmail,
                accountType : 'external',
                islhToken : sessionStorage.getItem("islhtoken")
              };
              let url = `${this.$store.state.islhurl}addAuthorUser`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.getSysUser();
                    this.modelAdd = false;
                    this.$Message.success(this.$t('saveSus'));
                    this.$refs.addUserForm.resetFields();
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleEdit(index) {
              if(index.accountType == "internal"){
                this.$Message.error(this.$t('updateMsg'));
                return;
              }
              this.updateFlag = 1;
              this.addUserForm.userAccount = index.userAccount;
              this.addUserForm.empName = index.empName;
              this.addUserForm.empEmail = index.empEmail;
              this.modelAdd = true;
            },
            modifyUser(){
              let params = {
                userAccount : this.addUserForm.userAccount,
                empName : this.addUserForm.empName,
                empEmail : this.addUserForm.empEmail,
                islhToken : sessionStorage.getItem("islhtoken")
              }
              // console.log(params)
              let url = `${this.$store.state.islhurl}modifyAuthorUser`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.getSysUser();
                    this.modelAdd = false;
                    this.$Message.success(this.$t('modifySus'));
                    this.$refs.addUserForm.resetFields();
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleSelectionChange(val) {
              this.multipleSelection = val;
            },
            handleReset(){
              const length = this.multipleSelection.length;
              if(length == 0 || length > 1){
                this.$Message.error(this.$t('resetMsg3'));
                return;
              }
              let accountType = this.multipleSelection[0].accountType;
              if(accountType == 'internal'){
                this.$Message.error(this.$t('resetMsg1'));
                return;
              }
              let mail = this.multipleSelection[0].empEmail;
              if(mail == null || mail == ""){
                this.$Message.error(this.$t('emailNull'));
                return false;
              }
              var msg1 = this.$t('resetMsg');
              var msg2 = this.$t('warnMsg');
              var msg3 = this.$t('confrim');
              var msg4 = this.$t('cancle');
              this.$confirm(msg1, msg2, {
                  confirmButtonText: msg3,
                  cancelButtonText: msg4,
                  type: 'warning'
              }).then(() => {
                let params = {
                  userAccount: this.multipleSelection[0].userAccount,
                  empEmail: this.multipleSelection[0].empEmail,
                  islhToken : sessionStorage.getItem("islhtoken")
                }
                let url = `${this.$store.state.islhurl}resetPassword`             
                this._post(url,params).then(
                  res => {
                    if(res == '200'){
                      var msg = this.$t('loginErrorMsg4');
                      this.$Message.success(msg);
                    }else{
                      this.$message({
                        type:'error',
                        showClose:true,
                        duration:10000,
                        message:res
                      });
                    }
                  }
                )
              }).catch(() => {
              });
            },
            getUserToRole(){
              let params = {
                userId : this.userId,
              }
              let url = `${this.$store.state.islhurl}getUserRoleByUserId`
              this._post(url,params).then(
                res =>{
                  let userRoles = res.userRoles;
                  if(userRoles !== null && userRoles.length > 0){
                    userRoles.forEach(item => {
                      if(item.roleKey === 'Role'){
                        let roles = this.roleData;
                        roles.forEach(role=> {
                          if(role.roleId === item.roleId){
                            this.$refs.roleTable.toggleRowSelection(role, true);
                          }
                        })
                      }else if(item.roleKey === 'Data'){
                        let datas = this.dataPermissions;
                        datas.forEach(data=> {
                          if(data.id === item.roleId){
                            this.$refs.dataTable.toggleRowSelection(data, true);
                          }
                        })
                      }
                    })
                  }else{
                    let datas = this.dataPermissions;
                    datas.forEach(data=> {
                      if(data.sysValue === 'Responsible' || data.sysValue === 'Founder'){
                        this.$refs.dataTable.toggleRowSelection(data, true);
                      }
                    })
                  }
                }
              )
            },
            handleEmpower(index){
              this.userId = index.userAccount;
              this.$refs.roleTable.clearSelection();
              this.$refs.dataTable.clearSelection();
              this.getUserToRole();
              this.modelEmpower = true;
            },
            handleRoleChange(val){
              this.multipleRole = val;
            },
            handleDataChange(val){
              this.multipleData = val;
            },
            submitEmpower(){
              let params = {
                userId : this.userId,
                roles : this.multipleRole,
                datas : this.multipleData,
              }
              let url = `${this.$store.state.islhurl}addUserRoleAndData`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.getSysUser();
                    this.modelEmpower = false;
                    this.$Message.success(this.$t('empowerMsg'));
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleFreeze(index){
              let params = {
                userAccount : index.userAccount,
                accountStatus : 1,
                islhToken : sessionStorage.getItem("islhtoken")
              }
              // console.log(params)
              let url = `${this.$store.state.islhurl}freezeUser`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.getSysUser();
                    this.$Message.success(this.$t('freezeMsg'));
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleUnFreeze(index){
              let params = {
                userAccount : index.userAccount,
                accountStatus : 0,
                islhToken : sessionStorage.getItem("islhtoken")
              }
              let url = `${this.$store.state.islhurl}unFreezeUser`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.getSysUser();
                    this.$Message.success(this.$t('unFreezeMsg'));
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            handleHour(index) {
              this.extraDate = null;
              this.userId = index.id;
              this.uAccount = index.userAccount;
              this.modelHour = true;
            },
            submitHour(){
              let params = {
                id : this.userId,
                userAccount : this.uAccount,
                extraDate : this.extraDate,
                islhToken : sessionStorage.getItem("islhtoken")
              }
              let url = `${this.$store.state.islhurl}user/extraDate`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.modelHour = false;
                    this.$Message.success("Operate successful");
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            },
            exportExcel(){
              this.exportLoading = true;
              let execlName = 'UserInfo.xlsx';
              const length = this.multipleSelection.length;
              let ids = [];
              for (let i = 0; i < length; i++) {
                ids.push(this.multipleSelection[i].id)
              }
              this.$axios({
                url: `${this.$store.state.islhurl}user/exportInfo`,
                method: 'post',
                data: {
                  ids: ids,
                  userAccount: this.userAccount==''?null:this.userAccount,
                  empName: this.empName==''?null:this.empName,
                  empEmail: this.empEmail==''?null:this.empEmail,
                  hasRole: this.hasRole,
                  islhToken : sessionStorage.getItem("islhtoken")
                },
                responseType:"blob"
              }).then(response=>{
                this.exportLoading = false;
                const blob = new Blob([response.data])
                const aEle = document.createElement('a');     // 创建a标签
                const href = window.URL.createObjectURL(blob);       // 创建下载的链接
                aEle.href = href;
                aEle.download = execlName;  // 下载后文件名
                document.body.appendChild(aEle);
                aEle.click();     // 点击下载 
                document.body.removeChild(aEle); // 下载完成移除元素
                window.URL.revokeObjectURL(href) // 释放掉blob对象
              })
            },
            addUser() {
              this.updateFlag = 0;
              this.addUserForm.userAccount = null;
              this.addUserForm.empName = null;
              this.addUserForm.empEmail = null;
              this.modelAdd = true;
            },
            close(){
              this.$refs.addUserForm.resetFields();
              this.modelAdd = false;
            },
            closeEmpower(){
              this.modelEmpower = false;
              this.modelHour = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getSysUser()
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getSysUser()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/sysdata/userList.vue